<template>
  <BaseModal modal-content-class="rest confirm_purch">
    <div class="content">
      <h1>{{ $_translations.value.modal_purchase_via_sms_title }}</h1>

      <BaseImage
        src="/static/images/store/store_confirm_sms.svg"
        alt="pin icon"
        class="top_img"
      />

      <p class="games-to-price"><span>{{ quantityText }} - {{ priceText }}</span></p>

      <p>{{ $_translations.value[descriptionText] }}</p>

      <p>
        {{ $_translations.value.modal_purchase_via_sms_instructions_pt1 }}
        “<span class=yellow_bold>
          {{ $_translateByOperator('modal_purchase_via_sms_instructions_pt2') }}
        </span>”
        {{ $_translations.value.modal_purchase_via_sms_instructions_pt3 }}
        <span class=yellow_bold>
          {{ $_translateByOperator('modal_purchase_via_sms_instructions_pt4') }}
        </span>.
      </p>
    </div>
  </BaseModal>
</template>

<script setup>
import { computed } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import { bundleTypeEnum } from '@/constants/bundle.js';

const props = defineProps({
  bundleType: {
    type: String,
    default: '',
  },
  quantityText: {
    type: String,
    default: '',
  },
  priceText: {
    type: String,
    default: '',
  },
});

const descriptionText = computed(() => {
  if (props.bundleType === bundleTypeEnum.GAMES) {
    return 'modal_purchase_via_sms_description_games';
  } else if (props.bundleType === bundleTypeEnum.JOKERS) {
    return 'modal_purchase_via_sms_description_jokers';
  } else {
    return '';
  }
});
</script>
